import Api from '@common/services/api';
import { APIEvaluationForm, PerformanceFormQuestion } from '../types';

export const createQuestion = async (
    organisationId: string,
    formId: string,
    payload: PerformanceFormQuestion | Record<never, never>
  ) => {
    const { data } = await Api.post<{ data: APIEvaluationForm }>(
      `/v1/organisations/${organisationId}/performance/forms/${formId}/components`,
      payload
    );

    return { data };
  };

